export default __webpack_public_path__ + "static/media/Supply-empty-state-icon.76d694b8.svg";